/* sk8 Monster Drops, tema 360, produto.js (refeito em 17/10/2026).
   Dono: frente da página de produto. Carrega só em templates/product.liquid,
   depois de base.js e gaveta.js (usa SK8.som, SK8.$, SK8.$$,
   SK8.atualizarSacola, SK8.abrirGaveta e SK8.rotas).

   O que mora aqui:
   - escolha de variante: a disponibilidade de cada tamanho sai das variantes
     da modelagem e da cor escolhidas. Tamanho que não existe na modelagem fica
     bloqueado ("Oversized vai do P ao GG"); se a pessoa estava num tamanho que
     some ao trocar a modelagem ou a cor, o tamanho é desmarcado e o botão pede
     "Escolha o tamanho". Sem combinação completa e disponível, o id da compra
     fica vazio: nada vai para a sacola diferente do que está na tela;
   - preço da variante (promoção de aniversário com a tabela riscada, Pix e
     parcelas sem juros), o resumo "Você escolheu" e as miniaturas;
   - "Adicionar à sacola" (AJAX e gaveta) e "Comprar agora" (sacola e o mesmo
     caminho do "Finalizar compra", que o sk8-checkout.js leva ao checkout);
   - a galeria com deslize, contador e setas, e a lupa em tela cheia;
   - o botão fixo no rodapé do celular quando o botão principal sai da vista;
   - rastreio (assets/sk8-rastreio.js): ViewContent uma vez ao abrir e AddToCart
     depois do 200 do /cart/add.js, com o preço já com os descontos da sacola.
   Expõe SK8.abrirLupa e SK8.fecharLupa (o Escape do base.js fecha a lupa). */
(function () {
  "use strict";

  var SK8 = window.SK8 || {};
  var $ = SK8.$ || function (s, r) { return (r || document).querySelector(s); };
  var $$ = SK8.$$ || function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var Som = SK8.som || { tocar: function () {} };
  var calmo = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function dinheiro(c) {
    var n = Math.round(Number(c) || 0), reais = String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var cent = String(n % 100);
    return "R$ " + reais + "," + (cent.length < 2 ? "0" + cent : cent);
  }
  function json(id) { try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return null; } }

  var form = $("#form-compra");
  if (!form) return;
  var variantes = json("dados-variantes") || [];
  var cfg = json("dados-produto") || {};
  var IM = typeof cfg.modelagem === "number" ? cfg.modelagem : -1;
  var IT = typeof cfg.tamanho === "number" ? cfg.tamanho : -1;
  var IC = typeof cfg.cor === "number" ? cfg.cor : -1;
  var pixPct = Number(cfg.pix) || 0, nParcelas = Math.max(1, Number(cfg.parcelas) || 1);
  var oferta = json("sk8-promocao-aniversario") || {};
  function promocaoAtiva() { return Number(oferta.percentual) > 0 && Number(oferta.percentual) < 100 && Date.parse(oferta.termina_em) > Date.now(); }
  // mesma conta do snippets/preco-promocional.liquid
  function precoPromocional(c) { return promocaoAtiva() ? c - Math.floor(c * Number(oferta.percentual) / 100 + 0.0000001) : c; }
  // mesma conta do checkout (src/calculo.js): desconto do Pix arredondado
  function precoPix(c) { return c - Math.round(c * pixPct / 100); }

  var campo = $("#variante", form), comprar = $("#botao-comprar", form), sacola = $("#botao-sacola", form);
  var erro = $("#compra-erro"), avisoTamanho = $("#tamanho-aviso");
  var grupos = {};
  $$("fieldset[data-opcao]", form).forEach(function (g) { grupos[Number(g.getAttribute("data-opcao"))] = g; });
  var nOpcoes = variantes.length ? variantes[0].o.length : 0;
  var grupoTamanho = grupos[IT] || null;
  var ordemTamanhos = grupoTamanho ? $$("[data-tamanho-compra] input[type=radio]", grupoTamanho).map(function (r) { return r.value; }) : [];

  /* ------------------------------------------------------------------ escolha de variante */
  function selecao() {
    var sel = [];
    for (var i = 0; i < nOpcoes; i++) {
      var g = grupos[i], r = g && $("input:checked", g);
      // opção sem seletor na tela (produto de variante única): vale o valor comum a todas as variantes
      if (!g) sel[i] = variantes.every(function (v) { return v.o[i] === variantes[0].o[i]; }) ? variantes[0].o[i] : null;
      else sel[i] = r ? r.value : null;
    }
    return sel;
  }
  // variantes que combinam com a escolha, ignorando as opções da lista "ignorar"
  function candidatas(sel, ignorar) {
    return variantes.filter(function (v) {
      return v.o.every(function (o, j) { return (ignorar && ignorar.indexOf(j) >= 0) || sel[j] == null || o === sel[j]; });
    });
  }
  function faixa(modelagem) {
    var tem = {};
    variantes.forEach(function (v) { if (IM < 0 || v.o[IM] === modelagem) tem[v.o[IT]] = true; });
    var lista = ordemTamanhos.filter(function (t) { return tem[t]; });
    return { lista: lista, primeiro: lista[0], ultimo: lista[lista.length - 1], completa: lista.length === ordemTamanhos.length };
  }
  var CAIMENTO = {
    regular: "corte reto",
    oversized: "ombro caído e corpo mais largo"
  };
  function textoLimite(modelagem) {
    var f = faixa(modelagem);
    return (modelagem || "Esta camiseta") + " vai do " + f.primeiro + " ao " + f.ultimo;
  }

  function mostrarErro(t) { if (erro) { erro.textContent = t || ""; erro.hidden = !t; } }
  function avisar(t) { if (avisoTamanho) { avisoTamanho.textContent = t || ""; avisoTamanho.hidden = !t; } }

  // desabilita tamanhos (e cores) que não existem ou estão esgotados na escolha atual;
  // devolve o tamanho que estava marcado e precisou sair, para o aviso
  function atualizarEstados(sel) {
    var saiu = null;
    if (grupoTamanho) {
      $$("[data-tamanho-compra] input[type=radio]", grupoTamanho).forEach(function (r) {
        var cand = variantes.filter(function (v) {
          return v.o[IT] === r.value && (IM < 0 || v.o[IM] === sel[IM]) && (IC < 0 || sel[IC] == null || v.o[IC] === sel[IC]);
        });
        var existe = cand.length > 0, disp = cand.some(function (v) { return v.d; });
        var label = r.closest("label");
        r.disabled = !disp;
        if (label) { label.classList.toggle("fora", !disp); label.classList.toggle("nao-existe", !existe); }
        var motivo = label && $("[data-motivo]", label);
        if (motivo) motivo.textContent = !existe ? ", não existe nesta modelagem" : !disp ? ", esgotado" : "";
        if (r.checked && !disp) { r.checked = false; saiu = { valor: r.value, existe: existe }; }
      });
      var limite = $("[data-limite]", grupoTamanho);
      if (limite) {
        var f = faixa(sel[IM]);
        limite.hidden = f.completa || !f.lista.length;
        if (!limite.hidden) limite.textContent = textoLimite(sel[IM]) + ".";
      }
    }
    // modelagem e cor: a opção sem nenhuma peça disponível (com a outra escolha) fica marcada como esgotada
    [IM, IC].forEach(function (i) {
      var g = grupos[i];
      if (!g) return;
      $$("input", g).forEach(function (r) {
        var s = sel.slice(); s[i] = r.value;
        var disp = candidatas(s, [IT]).some(function (v) { return v.d; });
        var label = r.closest("label");
        if (label) label.classList.toggle("fora", !disp);
      });
    });
    return saiu;
  }

  function atualizarMiniaturas(sel) {
    [IM, IC].forEach(function (i) {
      var g = grupos[i];
      if (!g) return;
      $$("input", g).forEach(function (r) {
        var img = $("[data-mini]", r.closest("label"));
        if (!img) return;
        var s = sel.slice(); s[i] = r.value;
        var com = candidatas(s, [IT]).filter(function (v) { return v.f; })[0];
        if (com && img.getAttribute("src") !== com.f) img.src = com.f;
      });
      var escolhido = $("[data-valor-escolhido]", g);
      if (escolhido) escolhido.textContent = sel[i] || "";
    });
    var caimento = grupos[IM] && $("[data-caimento]", grupos[IM]);
    if (caimento && sel[IM]) {
      var f = faixa(sel[IM]), desc = CAIMENTO[String(sel[IM]).toLowerCase()];
      caimento.textContent = sel[IM] + ": " + (desc ? desc + ", " : "") + "do " + f.primeiro + " ao " + f.ultimo;
    }
  }

  var valor = $("[data-preco-valor]"), tabela = $("[data-preco-tabela]"), tabelaValor = $("[data-preco-tabela-valor]");
  var selo = $("[data-preco-selo]"), promoLinha = $("[data-preco-promo]"), pixEl = $("[data-preco-pix]"), parcelaEl = $("[data-preco-parcela]");
  var barraPreco = $("[data-barra-preco]"), barraPix = $("[data-barra-pix]"), aPartir = $("[data-preco-apartir]");
  function pintarPreco(precoTabela, varios) {
    var ativo = promocaoAtiva(), final = precoPromocional(precoTabela);
    if (valor) valor.textContent = dinheiro(final);
    if (aPartir) aPartir.hidden = !varios;
    if (tabela) tabela.hidden = !ativo;
    if (tabelaValor) tabelaValor.textContent = dinheiro(precoTabela);
    if (selo) { selo.hidden = !ativo; if (ativo) selo.textContent = "-" + String(oferta.percentual).replace(".", ",") + "%"; }
    if (promoLinha) promoLinha.hidden = !ativo;
    if (pixEl) pixEl.textContent = dinheiro(precoPix(final));
    if (parcelaEl) parcelaEl.textContent = dinheiro(Math.ceil(final / nParcelas));
    if (barraPreco) barraPreco.textContent = (varios ? "a partir de " : "") + dinheiro(final);
    if (barraPix) barraPix.textContent = dinheiro(precoPix(final));
  }

  var resumoTexto = $("[data-resumo-texto]"), resumoFoto = $("[data-resumo-foto]");
  function pintarResumo(sel, v) {
    if (resumoTexto) {
      var partes = [];
      if (IM >= 0 && sel[IM]) partes.push(sel[IM]);
      if (IC >= 0 && sel[IC]) partes.push(sel[IC]);
      for (var i = 0; i < nOpcoes; i++) if (i !== IM && i !== IC && i !== IT && sel[i]) partes.push(sel[i]);
      var t = partes.join(" ");
      if (IT >= 0) t += sel[IT] ? (t ? ", " : "") + "tamanho " + sel[IT] : (t ? ", " : "") + "falta o tamanho";
      resumoTexto.textContent = t;
    }
    if (resumoFoto) {
      var com = v && v.f ? v : candidatas(sel, [IT]).filter(function (x) { return x.f; })[0];
      var src = com ? com.f : cfg.fotoPadrao;
      if (src && resumoFoto.getAttribute("src") !== src) resumoFoto.src = src;
    }
  }

  var atual = null, ocupado = false;
  function texto(botao, t) { var el = botao && $(".texto", botao); if (el) el.textContent = t; }
  var barraBotao = $("[data-barra-comprar]");
  function pintarBotoes(sel) {
    if (ocupado) return;
    var algum = candidatas(sel, [IT]).some(function (v) { return v.d; });
    var rotulo = atual ? "Comprar agora" : algum ? "Escolha o tamanho" : "Esgotado";
    texto(comprar, rotulo);
    if (comprar) comprar.disabled = !algum;
    if (sacola) sacola.disabled = !algum;
    if (barraBotao) { barraBotao.textContent = atual ? "Comprar agora" : algum ? "Escolha o tamanho" : "Esgotado"; barraBotao.disabled = !algum; }
  }

  // foto da variante: leva a galeria até a foto ligada à variante (sem mexer na página)
  var midiaAtual = null;
  function fotoDaVariante(v, suave) {
    var id = v && v.m;
    if (!id || id === midiaAtual) return;
    midiaAtual = id;
    var item = $(".galeria-item[data-media-id='" + id + "']");
    if (item) irPara(Number(item.getAttribute("data-indice")), suave);
  }

  function atualizar(op) {
    op = op || {};
    var sel = selecao();
    var saiu = atualizarEstados(sel);
    if (saiu) sel = selecao();
    atualizarMiniaturas(sel);
    var completa = sel.every(function (x) { return x != null; });
    var v = completa ? candidatas(sel)[0] : null;
    atual = v && v.d ? v : null;
    campo.value = atual ? atual.id : "";
    var base = candidatas(sel, [IT]).filter(function (x) { return x.d; });
    if (!base.length) base = candidatas(sel, [IT]);
    var precos = base.map(function (x) { return x.p; });
    if (atual) pintarPreco(atual.p, false);
    else if (precos.length) pintarPreco(Math.min.apply(null, precos), Math.min.apply(null, precos) !== Math.max.apply(null, precos));
    pintarResumo(sel, atual);
    pintarBotoes(sel);
    fotoDaVariante(atual || base.filter(function (x) { return x.m; })[0], !op.inicial);
    if (saiu && !op.inicial) {
      avisar(saiu.existe ? "O " + saiu.valor + " está esgotado nesta escolha. Escolha outro tamanho." : textoLimite(sel[IM]) + ". Escolha o tamanho.");
    }
    if (atual && !op.inicial) {
      try { history.replaceState(history.state, "", location.pathname + "?variant=" + atual.id); } catch (e) {}
    }
    marcarLinhaMedida(sel[IT]);
  }

  form.addEventListener("change", function (e) {
    if (!e.target.matches("input[type=radio]")) return;
    if (e.isTrusted) Som.tocar("tamanho");
    mostrarErro("");
    avisar("");
    if (grupoTamanho) grupoTamanho.classList.remove("pedir");
    atualizar();
  });
  // Enter num tamanho não envia o formulário
  form.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && e.target.matches("input[type=radio]")) e.preventDefault();
  });
  // tamanho bloqueado: o rádio está desligado, o clique cai no rótulo e explica o motivo
  if (grupoTamanho) grupoTamanho.addEventListener("click", function (e) {
    var label = e.target.closest && e.target.closest("[data-tamanho-compra] label.fora");
    if (!label || !grupoTamanho.contains(label)) return;
    e.preventDefault();
    Som.tocar("erro");
    var r = $("input", label), sel = selecao();
    avisar(label.classList.contains("nao-existe") ? textoLimite(sel[IM]) + "." : "O tamanho " + (r ? r.value : "") + " está esgotado nesta camiseta. Escolha outro tamanho.");
  });

  function pedirTamanho() {
    Som.tocar("erro");
    var alvo = grupoTamanho || form;
    avisar(grupoTamanho ? "Escolha o tamanho." : "");
    alvo.scrollIntoView({ behavior: calmo ? "auto" : "smooth", block: "center" });
    if (grupoTamanho) {
      grupoTamanho.classList.remove("pedir");
      void grupoTamanho.offsetWidth;
      grupoTamanho.classList.add("pedir");
      var primeiro = $("[data-tamanho-compra] input:not(:disabled)", grupoTamanho);
      if (primeiro) primeiro.focus({ preventScroll: true });
    }
  }

  /* ------------------------------------------------------------------ medidas: marca a linha do tamanho escolhido */
  function marcarLinhaMedida(t) {
    $$("[data-linha-tamanho]").forEach(function (tr) { tr.classList.toggle("ativa", tr.getAttribute("data-linha-tamanho") === t); });
  }

  /* ------------------------------------------------------------------ comprar e guardar
     Sem fetch (ou sem a gaveta), o formulário segue o caminho normal da Shopify.
     Erro de estoque ou de rede vira mensagem embaixo dos botões. */
  var quem = null;
  [comprar, sacola].forEach(function (b) { if (b) b.addEventListener("click", function () { quem = b; }); });
  function ocupar(botao, t) {
    ocupado = true;
    [comprar, sacola, barraBotao].forEach(function (b) { if (b) b.disabled = true; });
    botao.setAttribute("aria-busy", "true");
    var el = $(".texto", botao) || botao;
    if (botao._texto == null) { botao._texto = el.textContent; el.textContent = t; }
  }
  function liberar() {
    ocupado = false;
    [comprar, sacola, barraBotao].forEach(function (b) {
      if (!b) return;
      b.removeAttribute("aria-busy");
      if (b._texto != null) { var el = $(".texto", b) || b; el.textContent = b._texto; b._texto = null; }
    });
    pintarBotoes(selecao());
  }
  function lerSacola() {
    return fetch(SK8.rotas.sacola + ".js", { headers: { Accept: "application/json" }, cache: "no-store" })
      .then(function (r) { if (!r.ok) throw new Error("sacola"); return r.json(); });
  }
  // 429: a Shopify pediu calma; tenta de novo uma vez, 1,5 s depois
  function por(id, deNovo) {
    return fetch(SK8.rotas.adicionar + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (r.status === 429 && !deNovo) return new Promise(function (ok) { setTimeout(ok, 1500); }).then(function () { return por(id, true); });
      if (!r.ok) { var falha = new Error("sacola"); falha.status = r.status; throw falha; }
      return r.json().then(function (corpo) { rastrearAdicao(id, corpo); return corpo; });
    });
  }

  /* ------------------------------------------------------------------ rastreio (assets/sk8-rastreio.js)
     content_id = id da variante, como texto. Preço em centavos, já com os descontos da sacola
     (Niver incluído). Sem o sk8-rastreio.js (bloqueador), nada acontece. */
  function evento(nome, dados) { try { if (window.sk8Evento) window.sk8Evento(nome, dados); } catch (e) {} }
  function itemRastreio(id, centavos) {
    var nome = $("#nome-item");
    return window.sk8Evento ? window.sk8Evento.item(id, centavos, 1, nome ? nome.textContent.trim() : "") : null;
  }
  // preço de uma unidade como a Shopify cobra: preço da linha menos os descontos, dividido pela quantidade
  function precoCobrado(id, corpo) {
    var linha = ((corpo && corpo.items) || []).filter(function (i) { return String(i.variant_id) === String(id); })[0];
    if (linha && Number(linha.original_line_price) > 0) {
      var desc = (linha.discounts || []).reduce(function (s, d) { return s + (Number(d.amount) || 0); }, 0);
      return Math.round((Number(linha.original_line_price) - desc) / (Number(linha.quantity) || 1));
    }
    var v = variantes.filter(function (x) { return String(x.id) === String(id); })[0];
    return v ? precoPromocional(v.p) : 0;
  }
  // AddToCart: só depois do 200 do /cart/add.js, com a variante que entrou na sacola
  function rastrearAdicao(id, corpo) {
    try { evento("AddToCart", itemRastreio(id, precoCobrado(id, corpo))); } catch (e) {}
  }
  function explicar(falha) {
    Som.tocar("erro");
    var status = falha && falha.status;
    mostrarErro(status === 422 ? "Não há mais unidades deste tamanho em estoque. Escolha outro tamanho."
      : status === 429 ? "A loja recebeu muitos pedidos agora. Aguarde alguns segundos e tente novamente."
      : "Não foi possível adicionar à sacola. Verifique a sua conexão e tente novamente.");
  }
  // o id que vai para a sacola é sempre o da escolha na tela, conferido de novo na hora do clique
  function idDaTela() {
    var sel = selecao();
    if (!sel.every(function (x) { return x != null; })) return null;
    var v = candidatas(sel)[0];
    return v && v.d && String(v.id) === campo.value ? v.id : null;
  }

  function adicionar() {
    if (ocupado || !sacola || sacola.disabled) return;
    var id = idDaTela();
    if (!id) { pedirTamanho(); return; }
    ocupar(sacola, "Adicionando...");
    mostrarErro("");
    por(id).then(lerSacola).then(function (c) {
      if (SK8.atualizarSacola) SK8.atualizarSacola(c.item_count);
      Som.tocar("guardar");
      liberar();
      if (SK8.abrirGaveta) SK8.abrirGaveta(c, sacola);
    }).catch(function (falha) { explicar(falha); liberar(); });
  }
  function irAoPagamento() {
    var b = $("[data-ir-pagamento] [name='checkout']");
    if (b) b.click(); else location.href = SK8.rotas.pagamento;
    // se a página continuar aqui (rede lenta ou o checkout fora do ar), o botão volta
    setTimeout(function () { if (!document.hidden) liberar(); }, 9000);
  }
  function comprarAgora(botao) {
    if (ocupado || !comprar || comprar.disabled) return;
    var id = idDaTela();
    if (!id) { pedirTamanho(); return; }
    Som.tocar("confirmar");
    ocupar(botao || comprar, "Abrindo o pagamento...");
    mostrarErro("");
    // a peça que já está na sacola não entra de novo: só segue para o pagamento
    lerSacola().catch(function () { return null; }).then(function (c) {
      var ja = c && (c.items || []).some(function (i) { return i.variant_id === id; });
      return ja ? c : por(id);
    }).then(irAoPagamento).catch(function (falha) { explicar(falha); liberar(); });
  }
  form.addEventListener("submit", function (e) {
    var autor = e.submitter || quem;
    quem = null;
    if (!campo.value) { e.preventDefault(); pedirTamanho(); return; }
    if (!window.fetch) return;
    if (autor && autor === comprar) { e.preventDefault(); comprarAgora(comprar); return; }
    if (!SK8.abrirGaveta) return;
    e.preventDefault();
    adicionar();
  });
  // voltar do pagamento pelo navegador devolve a página da memória com os botões ocupados
  window.addEventListener("pageshow", function (e) { if (e.persisted) liberar(); });

  /* ------------------------------------------------------------------ botão fixo no rodapé (celular) */
  var barra = $("[data-barra-compra]"), blocoBotoes = $("[data-botoes]");
  // pela rolagem (e não por IntersectionObserver): um salto de rolagem que passa por cima do botão também conta.
  // Desde 20/10/2026 aparece também antes do botão (quem chega pelo anúncio não o vê na primeira tela);
  // nesse trecho o toque leva à escolha, para ninguém comprar o tamanho que veio marcado sem ver.
  var botoesAbaixo = false;
  if (barra && blocoBotoes) {
    var mostrando = false, pedido = 0;
    var conferirBarra = function () {
      pedido = 0;
      var caixa = blocoBotoes.getBoundingClientRect();
      botoesAbaixo = caixa.top > window.innerHeight;
      var mostrar = caixa.bottom < 0 || botoesAbaixo;
      if (mostrar === mostrando) return;
      mostrando = mostrar;
      barra.classList.toggle("visivel", mostrar);
      barra.setAttribute("aria-hidden", String(!mostrar));
      if (barraBotao) barraBotao.tabIndex = mostrar ? 0 : -1;
      document.documentElement.classList.toggle("com-barra-compra", mostrar);
    };
    var agendarBarra = function () { if (!pedido) pedido = requestAnimationFrame(conferirBarra); };
    window.addEventListener("scroll", agendarBarra, { passive: true });
    window.addEventListener("resize", agendarBarra, { passive: true });
    // foto e fonte que chegam depois empurram o botão sem rolagem nenhuma
    window.addEventListener("load", agendarBarra);
    if (window.ResizeObserver) new ResizeObserver(agendarBarra).observe(document.body);
    conferirBarra();
  }
  if (barraBotao) barraBotao.addEventListener("click", function () {
    if (botoesAbaixo && form) { form.scrollIntoView({ behavior: calmo ? "auto" : "smooth", block: "start" }); return; }
    if (!campo.value) { pedirTamanho(); return; }
    comprarAgora(barraBotao);
  });

  /* ------------------------------------------------------------------ galeria com deslize */
  var trilho = $("[data-galeria-trilho]"), itens = trilho ? $$(".galeria-item", trilho) : [];
  var contador = $("[data-galeria-contador]"), minis = $$("[data-ir-foto]");
  var indiceFoto = 0;
  // fotos 2 em diante nascem sem src (data-src): baixam quando a pessoa mexe na galeria,
  // quando a variante aponta para elas ou, a segunda, alguns segundos depois da carga
  function baixarFoto(i) {
    var im = itens[i] && $("img[data-galeria-pendente]", itens[i]);
    if (!im) return;
    im.removeAttribute("data-galeria-pendente");
    if (im.dataset.srcset) { im.srcset = im.dataset.srcset; delete im.dataset.srcset; }
    if (im.dataset.src) { im.src = im.dataset.src; delete im.dataset.src; }
  }
  function baixarTodas() { itens.forEach(function (it, i) { baixarFoto(i); }); }
  function irPara(i, suave) {
    if (!trilho || !itens.length) return;
    i = Math.max(0, Math.min(itens.length - 1, i));
    baixarFoto(i);
    trilho.scrollTo({ left: itens[i].offsetLeft - itens[0].offsetLeft, behavior: suave && !calmo ? "smooth" : "auto" });
    marcarFoto(i);
  }
  function marcarFoto(i) {
    indiceFoto = i;
    if (contador) contador.textContent = (i + 1) + " de " + itens.length;
    minis.forEach(function (b) { b.setAttribute("aria-current", String(Number(b.getAttribute("data-ir-foto")) === i)); });
  }
  if (trilho) {
    var quadro = 0;
    ["pointerdown", "touchstart", "focus"].forEach(function (ev) { trilho.addEventListener(ev, baixarTodas, { once: true, passive: true }); });
    window.addEventListener("load", function () { setTimeout(function () { baixarFoto(1); }, 2500); });
    trilho.addEventListener("scroll", function () {
      baixarTodas();
      if (quadro) return;
      quadro = requestAnimationFrame(function () {
        quadro = 0;
        var w = trilho.clientWidth || 1;
        var i = Math.round(trilho.scrollLeft / w);
        if (i !== indiceFoto) marcarFoto(Math.max(0, Math.min(itens.length - 1, i)));
      });
    }, { passive: true });
    trilho.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); irPara(indiceFoto + 1, true); }
      if (e.key === "ArrowLeft") { e.preventDefault(); irPara(indiceFoto - 1, true); }
    });
  }
  $$("[data-galeria-passo]").forEach(function (b) {
    b.addEventListener("click", function () { Som.tocar("mover"); baixarTodas(); irPara(indiceFoto + Number(b.getAttribute("data-galeria-passo")), true); });
  });
  minis.forEach(function (b) {
    b.addEventListener("click", function () { Som.tocar("mover"); irPara(Number(b.getAttribute("data-ir-foto")), true); });
  });
  $$("[data-abrir-foto]").forEach(function (b) {
    b.addEventListener("click", function () { abrirLupa(Number(b.getAttribute("data-abrir-foto"))); });
  });

  /* ------------------------------------------------------------------ lupa
     Foto em tela cheia com zoom de pinça, roda do mouse, dois toques e arrasto. */
  var lupa = $("#lupa");
  var fotos = itens.map(function (it) { return it.getAttribute("data-grande"); });
  var img = lupa && $("img", lupa), est = { s: 1, x: 0, y: 0, s0: 1 }, idx = 0, ponteiros = new Map(), pinca = null;
  function aplicar() { img.style.transform = "translate(" + est.x + "px," + est.y + "px) scale(" + est.s + ")"; }
  function encaixar() {
    var w = img.naturalWidth || 1000, h = img.naturalHeight || 1000;
    est.s0 = est.s = Math.min(innerWidth / w, innerHeight / h);
    est.x = (innerWidth - w * est.s) / 2; est.y = (innerHeight - h * est.s) / 2;
    aplicar();
  }
  function zoom(f, px, py) {
    var ns = Math.min(est.s0 * 6, Math.max(est.s0, est.s * f));
    est.x = px - (px - est.x) * (ns / est.s);
    est.y = py - (py - est.y) * (ns / est.s);
    est.s = ns;
    if (ns === est.s0) return encaixar();
    aplicar();
  }
  function mostrarFoto(n) {
    idx = (n + fotos.length) % fotos.length;
    img.onload = encaixar;
    img.src = fotos[idx];
    if (img.complete) encaixar();
    var c = $("[data-lupa-contagem]", lupa);
    if (c) c.textContent = (idx + 1) + " de " + fotos.length;
  }
  var abriuDe = null;
  function abrirLupa(n) {
    if (!lupa || !fotos.length) return;
    abriuDe = document.activeElement;
    img.style.left = "0"; img.style.top = "0";
    lupa.hidden = false;
    document.documentElement.style.overflow = "hidden";
    mostrarFoto(n || 0);
    Som.tocar("menu");
    var f = $("[data-fechar-lupa]", lupa);
    if (f) f.focus();
  }
  SK8.fecharLupa = function () {
    if (!lupa || lupa.hidden) return;
    lupa.hidden = true;
    document.documentElement.style.overflow = "";
    irPara(idx, false);
    if (abriuDe && abriuDe.focus) abriuDe.focus({ preventScroll: true });
  };
  SK8.abrirLupa = abrirLupa;
  if (lupa) {
    $$("[data-fechar-lupa]", lupa).forEach(function (b) { b.addEventListener("click", function () { Som.tocar("voltar"); SK8.fecharLupa(); }); });
    $$("[data-lupa-passo]", lupa).forEach(function (b) { b.addEventListener("click", function () { Som.tocar("mover"); mostrarFoto(idx + Number(b.getAttribute("data-lupa-passo"))); }); });
    lupa.addEventListener("wheel", function (e) { e.preventDefault(); zoom(e.deltaY < 0 ? 1.18 : 1 / 1.18, e.clientX, e.clientY); }, { passive: false });
    lupa.addEventListener("dblclick", function (e) { if (est.s > est.s0 * 1.05) encaixar(); else zoom(2.6, e.clientX, e.clientY); });
    lupa.addEventListener("pointerdown", function (e) {
      if (e.target.closest("button")) return;
      lupa.setPointerCapture(e.pointerId);
      ponteiros.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (ponteiros.size === 2) {
        var p = Array.from(ponteiros.values());
        pinca = { d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) };
      }
    });
    lupa.addEventListener("pointermove", function (e) {
      if (!ponteiros.has(e.pointerId)) return;
      var antes = ponteiros.get(e.pointerId);
      ponteiros.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (ponteiros.size === 2 && pinca) {
        var p = Array.from(ponteiros.values());
        var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        zoom(d / pinca.d, (p[0].x + p[1].x) / 2, (p[0].y + p[1].y) / 2);
        pinca.d = d;
      } else if (ponteiros.size === 1 && est.s > est.s0 * 1.01) {
        est.x += e.clientX - antes.x; est.y += e.clientY - antes.y; aplicar();
      }
    });
    var toque0 = null;
    lupa.addEventListener("pointerup", function (e) {
      var inicio = ponteiros.get(e.pointerId);
      ponteiros.delete(e.pointerId);
      if (ponteiros.size < 2) pinca = null;
      if (e.pointerType === "touch" && inicio) {
        var agora = Date.now();
        if (toque0 && agora - toque0.t < 300 && Math.hypot(toque0.x - e.clientX, toque0.y - e.clientY) < 30) {
          if (est.s > est.s0 * 1.05) encaixar(); else zoom(2.6, e.clientX, e.clientY);
          toque0 = null;
        } else toque0 = { t: agora, x: e.clientX, y: e.clientY };
      }
    });
    lupa.addEventListener("pointercancel", function (e) { ponteiros.delete(e.pointerId); pinca = null; });
    document.addEventListener("keydown", function (e) {
      if (lupa.hidden) return;
      if (e.key === "ArrowRight") { e.preventDefault(); mostrarFoto(idx + 1); }
      if (e.key === "ArrowLeft") { e.preventDefault(); mostrarFoto(idx - 1); }
      if (e.key === "+" || e.key === "=") zoom(1.3, innerWidth / 2, innerHeight / 2);
      if (e.key === "-") zoom(1 / 1.3, innerWidth / 2, innerHeight / 2);
      if (e.key === "Tab") {
        var bs = $$("button", lupa).filter(function (b) { return b.offsetParent; });
        if (!bs.length) return;
        var i = bs.indexOf(document.activeElement);
        e.preventDefault();
        bs[(i + (e.shiftKey ? -1 : 1) + bs.length) % bs.length].focus();
      }
    }, true);
    window.addEventListener("resize", function () { if (!lupa.hidden) encaixar(); });
  }

  /* ------------------------------------------------------------------ início */
  atualizar({ inicial: true });
  // ViewContent uma vez por página, com a variante marcada ao abrir (sem escolha completa, a
  // primeira à venda). Trocar de variante não repete o evento: o AddToCart leva a variante da hora.
  var vista = atual || variantes.filter(function (x) { return x.d; })[0] || variantes[0];
  if (vista) evento("ViewContent", itemRastreio(vista.id, precoPromocional(vista.p)));
  // a promoção acaba com a página aberta: o preço volta ao de tabela sem riscado
  if (promocaoAtiva()) setTimeout(function () { atualizar({ inicial: true }); }, Math.min(2147483647, Math.max(0, Date.parse(oferta.termina_em) - Date.now() + 50)));

  window.SK8 = SK8;
})();
